<script lang="ts">
  import type { Runner } from '$types/races';

  export let runner: Runner;
</script>

<td colspan="100" class="border">
  {#if runner?.scratchedTime}
    <div class="flex items-center pl-2">
      <span class="text-xs font-medium italic text-gray-700"
        >Scratched @ {runner.scratchedTime.toLocaleString('en-AU')}</span
      >
    </div>
  {/if}
</td>
